<!-- <div class="loading-container absolute top-0 right-0 bottom-0 left-0 backdrop-blur-sm z-10 backdrop-brightness-75"> -->
@if (loading | async) {
<div class="loading-container fixed top-0 right-0 bottom-0 left-0 z-10 backdrop-brightness-0 backdrop-opacity-40">
  <kendo-loader
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    [type]="'converging-spinner'"
    [themeColor]="'info'"
    [size]="'large'"></kendo-loader>
</div>
}
